export const productTypes = {
  'Recarga': 'Recarga',
  'Paquetico': 'Paquetico',
  'Pin': 'Pin',
  'Factura': 'Factura',
  'Seguro': 'Seguro'
};

export const productTypeList = Object
  .entries(productTypes)
  .map(([key, value]) => ({ key, value }));
